import React, {useState, useContext, useEffect} from "react";
import Accordion from "../../components/accordion/Accordion";
import {cleanDrops} from "../../hooks/helpers";
import HeadView from "../../containers/HeadView";
import {ButtonWithIcon} from "../../styles/Butttons";
import {ReactComponent as PlusIcon} from "../../assets/icons/plus.svg";
import ImgEncabezado from "../../components/imagenEncabezado/ImgEncabezado";
import TableFacilitators from "./components/TableFacilitators";
import FacilitatorsProvider, {FacilitatorsContext} from "../../context/FacilitatorsProvider";
import AddFacilitatorModal from "./components/AddModal";

function FacilitadoresView({theme}) {
   const {wineList, isLoading, barList} = useContext(FacilitatorsContext);
   const [status, setStatus] = useState([0, 0, 0]);
   const [addModal, setAddModal] = useState(false);

   const changeMode = (newVal, key) => {
      let nStatus = cleanDrops(status.length, key, newVal);
      setStatus([...nStatus]);
   };

   return (
      <>
         <HeadView>
            <></>
            <>
               <ButtonWithIcon
                  text="Crear nuevo facilitador"
                  Icon={PlusIcon}
                  classname="text"
                  action={() => {
                     setAddModal(true);
                  }}
               />
            </>
         </HeadView>
         <ImgEncabezado
            title="imágenes encabezado nuestros facilitadores"
            theme={theme}
            status={status[0]}
            changeMode={val => changeMode(val, 0)}
            titleDesc="Nuestros facilitadores"
            idUpdate={6}
            nameUpdate="Facilitator" 
         />
         <Accordion title="lista de facilitadores de vino" theme={theme} status={status[1]} changeMode={val => changeMode(val, 1)}>
            <TableFacilitators theme={theme} data={wineList} isLoading={false} />
         </Accordion>
         <Accordion title="lista de facilitadores de barra" theme={theme} status={status[2]} changeMode={val => changeMode(val, 2)}>
            <TableFacilitators theme={theme} data={barList} isLoading={false} />
         </Accordion>
         <AddFacilitatorModal isOpen={addModal} close={() => setAddModal(false)} theme={theme} />
      </>
   );
}

/* const FacilitadoresView = ({theme}) => (
   <FacilitatorsProvider>
      <Facilitadores theme={theme} />
   </FacilitatorsProvider>
); */

export default FacilitadoresView;
